import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { colors } from '../../../../theme';
import { InputText, Body1Text } from '../../../TextVariants';
import { formatMoney } from '../../../../functions/moneyFormat';

type LocalTheme = {
  color: string;
};

const useStyles = makeStyles({
  decoration: ({ color }: LocalTheme) => ({
    display: 'inline',
    color: color === 'secondary' ? colors.white : colors.madison,
  }),
  lightBlue: {
    color: colors.bright_turquoise,
  },
  spaceText: {
    '& :first-child': {
      marginRight: '0.3em',
    },
  },
});

export type Variant =
  | 'withAutoPx'
  | 'withoutAutoPx'
  | 'discountDescription'
  | 'none';

type Props = {
  variant: Variant;
  color?: 'primary' | 'secondary';
  basePrice?: number;
  fontSize?: string;
};

const AutoPxPriceLabel = ({
  variant,
  color = 'primary',
  basePrice = 0,
  fontSize = '',
}: Props): JSX.Element => {
  const classes = useStyles({ color });
  const AutoPx = (size = fontSize): JSX.Element => (
    <InputText className={classes.decoration} style={{ fontSize: size }}>
      Auto
      <span className={classes.lightBlue} style={{ fontSize: size }}>
        PX
      </span>
    </InputText>
  );

  switch (variant) {
    case 'withAutoPx': {
      return AutoPx();
    }
    case 'withoutAutoPx': {
      return (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classes.spaceText}
        >
          <Body1Text className={classes.decoration} style={{ fontSize }}>
            Precio Regular
          </Body1Text>
          <Body1Text className={classes.decoration} style={{ fontSize }}>
            {formatMoney(basePrice)}
          </Body1Text>
        </Grid>
      );
    }
    case 'discountDescription': {
      return (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classes.spaceText}
        >
          <Body1Text className={classes.decoration} style={{ fontSize }}>
            Descuento del 10% incluido con
          </Body1Text>
          {AutoPx()}
        </Grid>
      );
    }
    default: {
      return <div />;
    }
  }
};

export default AutoPxPriceLabel;
